export default __webpack_public_path__ + "static/media/mobile_home.44f84f9e.svg";